module.exports = (__webpack_require__(7))(461);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/ngx-webstorage/dist/app.js from dll-reference vendor
// module id = 122
// module chunks = 0